import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withModifiers as _withModifiers, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/feven_move.svg'
import _imports_1 from '@/assets/img/menu_right.svg'
import _imports_2 from '@/assets/img/close_brand_error.svg'
import _imports_3 from '@/assets/img/check.svg'
import _imports_4 from '@/assets/img/face_love_blue.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-c4957094")

_pushScopeId("data-v-c4957094")
const _hoisted_1 = { class: "h-100 finder" }
const _hoisted_2 = {
  key: 0,
  class: "noMatches page_padding text-center"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  class: "mb-5",
  src: _imports_0
}, null, -1)
const _hoisted_4 = { class: "mt-3 w-100 " }
const _hoisted_5 = { class: "mt-3 d-flex justify-content-center align-items-center" }
const _hoisted_6 = {
  key: 1,
  class: "match_container"
}
const _hoisted_7 = {
  class: "lottieAnimation",
  ref: "lottieExperience"
}
const _hoisted_8 = { class: "page_padding py-0" }
const _hoisted_9 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_10 = { class: "percentageContainer" }
const _hoisted_11 = { class: "amount" }
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "symbol" }, "%", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "gradientOverlay" }, null, -1)
const _hoisted_14 = { class: "question_bottom_div" }
const _hoisted_15 = { class: "question" }
const _hoisted_16 = { class: "page_padding py-0" }
const _hoisted_17 = { class: "shadowButtonsContainer fev_button" }
const _hoisted_18 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "mb-1"
}, null, -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("img", {
  src: _imports_3,
  class: "mb-1"
}, null, -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("img", {
  src: _imports_4,
  class: "mb-1"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any) => {
  const _component_localized_text = _resolveComponent("localized-text")
  const _component_toggle_switch = _resolveComponent("toggle-switch")
  const _component_chevron_fixed = _resolveComponent("chevron-fixed")
  const _component_person_info = _resolveComponent("person-info")
  const _component_hexagon = _resolveComponent("hexagon")
  const _component_love_face_shadow_bar = _resolveComponent("love-face-shadow-bar")
  const _component_report_question = _resolveComponent("report-question")
  const _component_full_horizontal_scroll = _resolveComponent("full-horizontal-scroll")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (!_ctx.match)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_localized_text, {
            localizedKey: "app_NessunProfiloInQuestArea",
            text: "Nessun profilo<br /> in quest'area",
            class: "fev_text1 fw_800 text-uppercase"
          }),
          _createVNode(_component_localized_text, {
            localizedKey: "app_TiRicordiamoCheSeNonTroviProfiliNellaTuaZonaPuoiCambiareLaTuaPosizioneUtilizzandoFevenMoveAllInternoDeiFiltriDiRicerca",
            text: "Ti ricordiamo che se non trovi profili nella tua zona puoi cambiare la tua posizione utilizzando Feven Move all’interno dei filtri di ricerca.",
            class: "fev_text5 mt-2 d-block"
          }),
          _createVNode("button", {
            class: "btn fev_button bg_brand refuseButton mt-4",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('openFilter')))
          }, [
            _createVNode(_component_localized_text, {
              localizedKey: "app_CambiaPosizione",
              text: "Cambia Posizione",
              class: "text-uppercase"
            })
          ]),
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_localized_text, {
              localizedKey: "app_OppureAttiva",
              text: "Oppure Attiva",
              class: "fev_text6 text-lowercase"
            }),
            _createVNode("div", _hoisted_5, [
              _createVNode(_component_localized_text, {
                localizedKey: "app_TrovaLaPersonaPiùVicinaAMeAncheSeFuoriDalMioRange",
                text: "Trova la persona più vicina a me anche se fuori dal mio range",
                class: "me-3 fev_text6 fw_700 blue"
              }),
              _createVNode(_component_toggle_switch, {
                modelValue: _ctx.filter.findUserOutsideMyRange,
                "onUpdate:modelValue": _ctx.setFindUserOutsideMyRange,
                activeText: _ctx.$localizationService.getLocalizedValue('app_Si', 'Si'),
                inactiveText: _ctx.$localizationService.getLocalizedValue('app_No', 'No')
              }, null, 8, ["modelValue", "onUpdate:modelValue", "activeText", "inactiveText"])
            ])
          ])
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_6, [
          (_ctx.match.biography)
            ? (_openBlock(), _createBlock(_component_chevron_fixed, {
                key: 0,
                vertical: "top",
                horizontal: "right",
                class: ["whiteRightBg", {op_5 : !_ctx.match.biography}]
              }, {
                default: _withId(() => [
                  _createVNode("img", {
                    src: _imports_1,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('openDescription')))
                  })
                ]),
                _: 1
              }, 8, ["class"]))
            : _createCommentVNode("", true),
          (_ctx.match.hasAnyExperience)
            ? (_openBlock(), _createBlock(_component_chevron_fixed, {
                key: 1,
                vertical: "top",
                horizontal: "right",
                class: ["whiteRightBg", { 'marginTopFromOtherChevronFixed' : _ctx.match.biography }]
              }, {
                default: _withId(() => [
                  (_ctx.match.biography)
                    ? (_openBlock(), _createBlock("div", {
                        key: 0,
                        class: "invisible_div",
                        onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$emit('openDescription')), ["stop","prevent"]))
                      }))
                    : _createCommentVNode("", true),
                  _createVNode("div", {
                    class: "lottieContainer bg_experience",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('openExperienceList')))
                  }, [
                    _createVNode("div", _hoisted_7, null, 512)
                  ])
                ]),
                _: 1
              }, 8, ["class"]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_8, [
            _createVNode(_component_person_info, {
              name: _ctx.match.personName,
              birthDate: _ctx.match.birthDate,
              distanceMeters: _ctx.match.distanceMeters,
              sexualOrientation: _ctx.match.sexualOrientation,
              left: true
            }, null, 8, ["name", "birthDate", "distanceMeters", "sexualOrientation"]),
            _createVNode("div", {
              class: ["otherMatchResultContainer", _ctx.match.affinityRateReachedFromOther != null ? 'hasOtherMatchCompleted' : '']
            }, [
              (_ctx.match.affinityRateReachedFromOther != null)
                ? (_openBlock(), _createBlock("div", _hoisted_9, [
                    _createVNode(_component_hexagon, null, {
                      default: _withId(() => [
                        _createVNode("div", _hoisted_10, [
                          _createVNode("span", _hoisted_11, _toDisplayString(_ctx.match.affinityRateReachedFromOther), 1),
                          _hoisted_12
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_localized_text, {
                      localizedKey: "app_{{Name}}HaRaggiuntoIlTuoAffinityRate",
                      text: "{{Name}} ha raggiunto il tuo Affinity Rate!",
                      object: { Name: _ctx.$filters.cutNameTooLong(_ctx.match.personName) },
                      class: "fev_text6"
                    }, null, 8, ["object"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.match.minimumAffinityRate > 0)
                ? (_openBlock(), _createBlock(_component_love_face_shadow_bar, {
                    key: 1,
                    text: _ctx.affinityRateText
                  }, null, 8, ["text"]))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          _createVNode("div", {
            class: ["card_container", _ctx.match.affinityRateReachedFromOther != null ? 'hasOtherMatchCompleted' : '']
          }, [
            _createVNode(_component_full_horizontal_scroll, { class: "px-4 py-0" }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.match.questions, (question, index) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "imageCardContainer bg_blue",
                    key: index,
                    style: 'background-image: url(\'' + (question.noBlurImageUrl ? question.noBlurImageUrl : question.blurredImageUrl) + '\')'
                  }, [
                    _hoisted_13,
                    _createVNode(_component_report_question, {
                      matchIdentifier: _ctx.match.matchIdentifier,
                      questionIndex: index,
                      appUserIdentifier: _ctx.match.appUserIdentifier
                    }, null, 8, ["matchIdentifier", "questionIndex", "appUserIdentifier"]),
                    _createVNode("div", _hoisted_14, [
                      _createVNode("div", _hoisted_15, [
                        _createVNode("span", null, _toDisplayString(question.question), 1)
                      ]),
                      (_ctx.match.affinityRateReachedFromOther)
                        ? (_openBlock(), _createBlock("button", {
                            key: 0,
                            class: "fev_button bg_brand",
                            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.viewQuestionAndAnswers && _ctx.viewQuestionAndAnswers(...args)))
                          }, [
                            _createVNode(_component_localized_text, {
                              class: "fev_text7 fw_700",
                              localizedKey: "app_GuardaRisposte",
                              text: "Guarda risposte"
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ], 4))
                }), 128))
              ]),
              _: 1
            })
          ], 2),
          _createVNode("div", _hoisted_16, [
            _createVNode("div", _hoisted_17, [
              _createVNode("button", {
                class: "btn",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('next')))
              }, [
                _hoisted_18,
                _createVNode(_component_localized_text, {
                  localizedKey: "app_Scarta",
                  text: "Scarta",
                  class: "text-uppercase transparent bg_brand_error bg_on_text"
                })
              ]),
              _hoisted_19,
              (_ctx.match.affinityRateReachedFromOther == null)
                ? (_openBlock(), _createBlock("button", {
                    key: 0,
                    class: "btn",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('replyToMatch')))
                  }, [
                    _hoisted_20,
                    _createVNode(_component_localized_text, {
                      localizedKey: "app_reply",
                      text: "Reply",
                      class: "text-uppercase"
                    })
                  ]))
                : (_openBlock(), _createBlock("button", {
                    key: 1,
                    class: "btn",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('createChatCheck')))
                  }, [
                    _hoisted_21,
                    _createVNode(_component_localized_text, {
                      localizedKey: "app_crea<br>Affinità",
                      text: "Crea<br /> affinità",
                      class: "text-uppercase"
                    })
                  ]))
            ])
          ])
        ]))
  ]))
})